import React from 'react';
import { Box, Typography, Stack, Paper, Skeleton } from '@mui/material';
import InfoToolTip from 'containers/common/components/InfoToolTip';

function CalendarSkeleton() {
  const daysOfWeek = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
  const weeks = 3; // Show 3 weeks of skeleton

  return (
    <Box>
      <Typography variant="pageTitle" mb={3}>
        Calendar
        <InfoToolTip title="View and manage your calendar events" />
      </Typography>

      <Paper sx={{ p: 3 }}>
        {/* Header with navigation */}
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={3}>
          <Stack direction="row" alignItems="center" gap={2}>
            <Skeleton variant="rectangular" width={80} height={36} sx={{ borderRadius: 1 }} />
            <Skeleton variant="circular" width={36} height={36} />
            <Skeleton variant="circular" width={36} height={36} />
            <Skeleton variant="text" width={150} height={32} />
          </Stack>
          <Skeleton variant="rectangular" width={100} height={36} sx={{ borderRadius: 1 }} />
        </Stack>

        {/* Calendar Grid */}
        <Box>
          {/* Day headers */}
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(7, 1fr)',
              gap: 1,
              mb: 1,
            }}
          >
            {daysOfWeek.map(day => (
              <Box
                key={day}
                sx={{
                  textAlign: 'center',
                  py: 1,
                  borderBottom: '1px solid',
                  borderColor: 'divider',
                }}
              >
                <Typography variant="subtitle2" fontWeight={600}>
                  {day}
                </Typography>
              </Box>
            ))}
          </Box>

          {/* Calendar cells */}
          {[...Array(weeks)].map((__, weekIndex) => (
            <Box
              key={weekIndex}
              sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(7, 1fr)',
                gap: 1,
                mb: 1,
              }}
            >
              {[...Array(7)].map((_, dayIndex) => (
                <Box
                  key={dayIndex}
                  sx={{
                    border: '1px solid',
                    borderColor: 'divider',
                    minHeight: 120,
                    p: 1,
                    backgroundColor: 'background.paper',
                  }}
                >
                  <Skeleton variant="text" width={30} height={24} />
                  <Stack spacing={0.5} mt={1}>
                    {dayIndex % 3 === 0 && <Skeleton variant="rectangular" width="100%" height={20} />}
                    {dayIndex % 4 === 0 && <Skeleton variant="rectangular" width="100%" height={20} />}
                  </Stack>
                </Box>
              ))}
            </Box>
          ))}
        </Box>
      </Paper>
    </Box>
  );
}

export default CalendarSkeleton;
